
export const ValidateTestMethodInput = (testMethod, _createErrorMessage) => {
  if (!testMethod) {
    _createErrorMessage("106");
    return false;
  }

  return true;
};
